import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { AssetService } from '../../../asset/service/asset.service';
import { AuthService } from '../../../security/service/auth.service';
import { ProductUIMessages } from '../../model/product-ui.messages';
import { ProductRoutingStates } from '../../product-routing.module';
import { ProductService } from '../../service/product.service';
import { ProductBaseComponent } from '../product-base.component';

@Component({
  selector: 'product-add',
  templateUrl:
    './console/app-js/modules/product/components/add/product-add.component.html'
})
export class ProductAddComponent extends ProductBaseComponent
  implements AddeableComponent {
  protected nameAlreadyInUse = false;
  protected saving = false;

  /**
   * @constructor
   * @param {productService} productService
   */
  constructor(
    toastr: ToastrService,
    progressService: NgProgress,
    authService: AuthService,
    productService: ProductService,
    assetService: AssetService,
    private router: Router
  ) {
    super(progressService, toastr, authService, productService, assetService);
    this.loadMakesList();
    this.loadAssetTypes();
  }

  /**
   * 1. Validates if current name is not used by another product.
   * 2. Saves the new product info.
   */
  onSave(): void {
    this.saving = true;
    this.partAndProductModel.type = 'Machine';
    this.partAndProductModel.typeId = 2;
    this.productService.createProduct(this.partAndProductModel).subscribe(
      (result: any) => {
        this.saving = false;
        let productId = result.results.id;
        this.onAPISuccess(ProductUIMessages.ADD_PRODUCT_SUCCESS);
        this.router.navigate([
          `/console/${ProductRoutingStates.LIST.url}`,
          productId,
          'view'
        ]);
      },
      () => {
        this.saving = false;
        this.onAPIError(ProductUIMessages.ADD_PRODUCT_ERROR);
      }
    );
  }

  onCancel(): void {
    this.router.navigate([`/console/${ProductRoutingStates.LIST.url}`]);
  }
}
